import { useMemo } from 'react';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';
import { useAngularModalState } from '@web/common/hooks/useAngularModalState';
import { ShiftTasksBridgeState } from '@web/shiftTasks/ShiftTasksBridgeProvider/shiftTasksBridgeProvider.types';
import { ShiftTasksBridgeProvider } from '@web/shiftTasks/ShiftTasksBridgeProvider/ShiftTasksBridgeProvider';
import { TaskTemplateFormValues } from '@web/shiftTasks/ComposeTask/types/TaskTemplateFormValues';
import { TaskTemplate } from '@web/shiftTasks/types/TaskTemplate';

import { AddTaskTemplate } from './AddTaskTemplate';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmitSuccess?: (template: TaskTemplate) => void;
  shiftTasksReactBridge: ShiftTasksBridgeState;
  sourceTemplate: TaskTemplateFormValues;
};

export const AddTaskTemplateAngular = ({
  isOpen,
  onClose,
  onSubmitSuccess,
  shiftTasksReactBridge,
  sourceTemplate,
}: Props) => {
  const template = useMemo(() => mapAngularTemplateToFormValues(sourceTemplate), [sourceTemplate]);
  const modalState = useAngularModalState(isOpen, onClose);

  return (
    <ShiftTasksBridgeProvider shiftTasksBridge={shiftTasksReactBridge}>
      <QueryClientProvider>
        {modalState.isVisible && (
          <AddTaskTemplate
            modalState={modalState}
            sourceTemplate={template}
            onSubmitSuccess={onSubmitSuccess}
          />
        )}

        <ToastComponent />
      </QueryClientProvider>
    </ShiftTasksBridgeProvider>
  );
};

function mapAngularTemplateToFormValues(taskTemplate: any): TaskTemplateFormValues {
  if (!taskTemplate) {
    return null;
  }

  const { attachments = [], title, description, subtasks } = taskTemplate;
  return {
    attachments,
    title,
    description,
    subtasks: subtasks?.map((s) => ({ title: s.title })) || [],
  };
}
